import { Component, Input } from '@angular/core'
import {
    formatJobResultSelections,
    JobResultSelectionRef,
    NeighborhoodEnrichmentResult,
} from '../../../state/case/case.state'
import { HttpErrorResponse } from '@angular/common/http'
import { DownloadService } from '../../../shared/services/download.service'
import { ToasterService } from '../../../shared/services/toaster.service'

@Component({
    selector: 'app-neighborhood-enrichment-result-content',
    templateUrl: './neighborhood-enrichment-result-content.component.html',
    styleUrls: ['./neighborhood-enrichment-result-content.component.scss'],
})
export class NeighborhoodEnrichmentResultContent {
    @Input()
    neighborhoodEnrichmentEntry: NeighborhoodEnrichmentResult

    constructor(private downloadService: DownloadService, private toaster: ToasterService) {}

    detailsVisible = false

    formatSelections(selections: JobResultSelectionRef[] | undefined): string {
        return formatJobResultSelections(selections)
    }

    toggleDetails(): void {
        this.detailsVisible = !this.detailsVisible
    }

    downloadData(): void {
        this.downloadService
            .downloadNeighborhoodEnrichment(this.neighborhoodEnrichmentEntry.download_File)
            .subscribe({
                error: (err: HttpErrorResponse) => {
                    this.toaster.httpError(
                        err,
                        `Failed to download Neighborhood enrichment ${this.neighborhoodEnrichmentEntry.name}.`
                    )
                },
            })
    }
}
